<script>
  export let width = '100%';
  export let height = '200px';
</script>

<!-- Inline style for dynamic width and height -->
<div class="skeleton" style="width: {width}; height: {height};"></div>

<style>
  .skeleton {
    position: relative;
    overflow: hidden;
    background-color: #ddd;
    border-radius: 4px;
  }

  .skeleton::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    animation: loading 1.5s infinite;
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
</style>
